export default __webpack_public_path__ + "c25f2e80bad944363fe8266a33cb1ee5.svg";